import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloTemplateLanguagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrelloTemplateLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateLanguages"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"optIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"StringValue","value":"TrelloTemplates","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloTemplateLanguages","document":TrelloTemplateLanguagesDocument}} as const;
export type TrelloTemplateLanguagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TrelloTemplateLanguagesQuery = (
  { __typename: 'Query' }
  & { trello: (
    { __typename: 'TrelloQueryApi' }
    & { templateLanguages?: Types.Maybe<Array<(
      { __typename: 'TrelloTemplateGalleryLanguage' }
      & Pick<Types.TrelloTemplateGalleryLanguage, 'description' | 'enabled' | 'language' | 'locale' | 'localizedDescription'>
    )>> }
  ) }
);

/**
 * __useTrelloTemplateLanguagesQuery__
 *
 * To run a query within a React component, call `useTrelloTemplateLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrelloTemplateLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrelloTemplateLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrelloTemplateLanguagesQuery(
  baseOptions?: TrelloQueryHookOptions<
    TrelloTemplateLanguagesQuery,
    TrelloTemplateLanguagesQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: TrelloTemplateLanguagesDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    TrelloTemplateLanguagesQuery,
    TrelloTemplateLanguagesQueryVariables
  >(TrelloTemplateLanguagesDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useTrelloTemplateLanguagesLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    TrelloTemplateLanguagesQuery,
    TrelloTemplateLanguagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TrelloTemplateLanguagesQuery,
    TrelloTemplateLanguagesQueryVariables
  >(TrelloTemplateLanguagesDocument, options);
}
export function useTrelloTemplateLanguagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        TrelloTemplateLanguagesQuery,
        TrelloTemplateLanguagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TrelloTemplateLanguagesQuery,
    TrelloTemplateLanguagesQueryVariables
  >(TrelloTemplateLanguagesDocument, options);
}
export type TrelloTemplateLanguagesQueryHookResult = ReturnType<
  typeof useTrelloTemplateLanguagesQuery
>;
export type TrelloTemplateLanguagesLazyQueryHookResult = ReturnType<
  typeof useTrelloTemplateLanguagesLazyQuery
>;
export type TrelloTemplateLanguagesSuspenseQueryHookResult = ReturnType<
  typeof useTrelloTemplateLanguagesSuspenseQuery
>;
export type TrelloTemplateLanguagesQueryResult = Apollo.QueryResult<
  TrelloTemplateLanguagesQuery,
  TrelloTemplateLanguagesQueryVariables
>;
